export const EMAIL_PROVIDER = 'email'